// extracted by mini-css-extract-plugin
export default {"root":"FZrJhPYVLM","extraScrollSpacing":"m_yqxHO9Ou"};